import React, { useEffect, useState } from 'react';
import { LoginPayLayout } from '../components/portal/login-pay/LoginPayLayout';
import { SignIn } from '../components/portal/login-pay/SignIn';
import { EmailVerification } from '../components/portal/login-pay/EmailVerification';
import { AccountDashboard } from '../components/portal/login-pay/AccountDashboard';
import { ConfirmAndDone } from '../components/portal/quick-pay/ConfirmAndDone';
import type { PaymentData } from '../components/portal/quick-pay/BalanceAndPay';
import { useScreenInit } from '../useScreenInit';
type Stage = 'sign-in' | 'verify' | 'dashboard' | 'confirm';
function generateConfirmationNumber() {
  return 'CRG-' + Math.random().toString(36).slice(2, 6).toUpperCase() + '-' + Math.random().toString(36).slice(2, 6).toUpperCase();
}
function stepForStage(stage: Stage): 1 | 2 | 3 {
  if (stage === 'sign-in' || stage === 'verify') return 1;
  if (stage === 'dashboard') return 2;
  return 3;
}
export function LoginPayFlow() {
  const seed = useScreenInit() as {
    stage?: Stage;
    email?: string;
    paymentData?: PaymentData;
    isConfirmed?: boolean;
    confirmationNumber?: string;
  } | undefined;
  const [stage, setStage] = useState<Stage>(seed?.stage ?? 'sign-in');
  const [email, setEmail] = useState(seed?.email ?? '');
  const [paymentData, setPaymentData] = useState<PaymentData | null>(seed?.paymentData ?? null);
  const [isConfirmed, setIsConfirmed] = useState(seed?.isConfirmed ?? false);
  const [confirmationNumber, setConfirmationNumber] = useState(seed?.confirmationNumber ?? '');
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, [stage, isConfirmed]);
  const goBack = () => {
    if (stage === 'verify') setStage('sign-in');else if (stage === 'dashboard') setStage('sign-in');else if (stage === 'confirm') setStage('dashboard');
  };
  return <LoginPayLayout currentStep={stepForStage(stage)} showSuccess={isConfirmed} onBack={stage !== 'sign-in' && !isConfirmed ? goBack : undefined} wide={stage === 'dashboard'} data-id="element-1434">
      {stage === 'sign-in' && <SignIn initialEmail={email} onSignIn={(submittedEmail, isFirstTime) => {
      setEmail(submittedEmail);
      setStage(isFirstTime ? 'verify' : 'dashboard');
    }} data-id="element-1435" />}
      {stage === 'verify' && <EmailVerification email={email} onGoBack={() => setStage('sign-in')} onContinue={() => setStage('dashboard')} data-id="element-1436" />}
      {stage === 'dashboard' && <AccountDashboard email={email} onContinue={data => {
      setPaymentData(data);
      setStage('confirm');
    }} data-id="element-1437" />}
      {stage === 'confirm' && paymentData && <ConfirmAndDone paymentData={paymentData} isConfirmed={isConfirmed} confirmationNumber={confirmationNumber} onConfirm={() => {
      setConfirmationNumber(generateConfirmationNumber());
      setIsConfirmed(true);
    }} data-id="element-1438" />}
    </LoginPayLayout>;
}